import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from 'assets/images/logo.png';

const NAV_LINKS = [
  { to: '/#features',      label: 'Features' },
  { to: '/#ai-agent',      label: 'AI Agent' },
  { to: '/#integrations',  label: 'Integrations' },
  { to: '/#how-it-works',  label: 'How it works' },
  { to: '/#pricing',       label: 'Pricing' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <style>{`
        .nav-link-item {
          position: relative;
          padding: 6px 0;
          font-size: 13.5px;
          font-weight: 450;
          color: #52525B;
          text-decoration: none;
          transition: color 0.2s;
          letter-spacing: 0.01em;
        }
        .nav-link-item:hover { color: #111; }
        .header-login-btn:hover { color: #111 !important; border-color: rgba(0,0,0,0.35) !important; }
        .header-signup-btn:hover { opacity: 0.85; }
        .header-login-btn, .header-signup-btn { transition: all 0.2s ease; }
        @media (max-width: 768px) {
          .hidden-mobile { display: none !important; }
          .show-mobile { display: block !important; }
        }
        @media (min-width: 769px) {
          .show-mobile { display: none !important; }
        }
      `}</style>

      <header
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
          transition: 'all 0.3s ease',
          background: scrolled ? 'rgba(255,255,255,0.82)' : 'transparent',
          backdropFilter: scrolled ? 'blur(16px)' : 'none',
          WebkitBackdropFilter: scrolled ? 'blur(16px)' : 'none',
          borderBottom: scrolled ? '1px solid #E5E6EF' : '1px solid transparent',
        }}
      >
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 32px', height: 66, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

          {/* Logo */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', background: '#fff', border: '1px solid #E5E6EF', borderRadius: 6, padding: '4px 8px' }}>
              <img src={logo} alt="OneBotAds" style={{ height: 24 }} />
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav style={{ display: 'flex', gap: 30, alignItems: 'center' }} className="hidden-mobile">
            {NAV_LINKS.map(l => (
              <HashLink key={l.to} smooth to={l.to} className="nav-link-item">{l.label}</HashLink>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }} className="hidden-mobile">
            <NavLink to="/login" className="header-login-btn" style={{
              padding: '8px 18px', borderRadius: 999,
              border: '1px solid rgba(0,0,0,0.18)',
              color: '#52525B', fontSize: 13.5, fontWeight: 500,
              textDecoration: 'none',
              background: 'transparent',
            }}>Log in</NavLink>
            <NavLink to="/signup" className="header-signup-btn" style={{
              padding: '8px 18px', borderRadius: 999,
              background: '#221C51',
              color: '#fff', fontSize: 13.5, fontWeight: 600,
              textDecoration: 'none',
              display: 'inline-block',
            }}>Get Started</NavLink>
          </div>

          {/* Hamburger */}
          <button
            onClick={() => setOpen(o => !o)}
            className="show-mobile"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6 }}
          >
            <div style={{ width: 22, height: 1.5, background: '#111', marginBottom: 6, transition: 'all 0.2s', transform: open ? 'rotate(45deg) translate(5px,5px)' : 'none' }} />
            <div style={{ width: 22, height: 1.5, background: '#111', marginBottom: 6, opacity: open ? 0 : 1, transition: 'all 0.2s' }} />
            <div style={{ width: 22, height: 1.5, background: '#111', transition: 'all 0.2s', transform: open ? 'rotate(-45deg) translate(5px,-5px)' : 'none' }} />
          </button>
        </div>

        {/* Mobile Menu */}
        {open && (
          <div style={{
            background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(16px)',
            borderTop: '1px solid #E5E6EF',
            padding: '16px 32px 28px',
          }}>
            {NAV_LINKS.map(l => (
              <HashLink key={l.to} smooth to={l.to}
                onClick={() => setOpen(false)}
                style={{ display: 'block', padding: '14px 0', color: '#52525B', textDecoration: 'none', fontSize: 15, borderBottom: '1px solid #E5E6EF', fontWeight: 450 }}
              >{l.label}</HashLink>
            ))}
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <NavLink to="/login" onClick={() => setOpen(false)}
                style={{ flex: 1, textAlign: 'center', padding: '12px', borderRadius: 999, border: '1px solid rgba(0,0,0,0.18)', color: '#52525B', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}
              >Log in</NavLink>
              <NavLink to="/signup" onClick={() => setOpen(false)}
                style={{ flex: 1, textAlign: 'center', padding: '12px', borderRadius: 999, background: '#221C51', color: '#fff', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}
              >Get Started</NavLink>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
